import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { BaseInputProps, SelectItemOption } from 'components/common/sharedInterfaces/input.interfaces';
import { useViewport } from 'context/viewportContext';
import { getFormControlError } from 'lib/utils/form';
import { Controller } from 'react-hook-form';

interface Props extends BaseInputProps {
    options: SelectItemOption[];
    defaultValue?: SelectItemOption;
    disabled?: boolean;
}

const UbiSelect = ({ name, control, label, defaultValue, disabled, rules, fieldError, formErrorTObject, options = [] }: Props) => {
    const { isMobile } = useViewport();
    return (
        <FormControl fullWidth error={!!fieldError}>
            <InputLabel
                sx={{
                    fontSize: '1.8rem',
                    '@media (max-width: 768px)': {
                        fontSize: '1.4rem',
                    },
                    color: '#B9BABD',
                    '&[data-shrink="false"]': {
                        top: isMobile ? '' : '5.5px',
                    },
                    '&.Mui-error': {
                        color: '#B9BABD',
                    },
                }}>
                {label}
            </InputLabel>
            <Controller
                name={name as string}
                control={control}
                rules={rules}
                render={({ field: { onChange, onBlur, value } }) => (
                    <Select
                        label={label}
                        sx={{
                            height: 70,
                            fontSize: '1.8rem',
                            '@media (max-width: 768px)': {
                                height: 52,
                                fontSize: '1.4rem',
                            },
                        }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={defaultValue}
                        disabled={disabled}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}>
                        {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            />
            <FormHelperText>{getFormControlError(formErrorTObject, name as string, fieldError?.type)}</FormHelperText>
        </FormControl>
    );
};

export default UbiSelect;
